import AuthPanel from '@components/v2/layout/AuthPanel/AuthPanel';
import Loading from '@components/v2/ui/Loading/Loading';
import * as React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import AuthShell from '../../login/components/AuthShell';
import OAuthConsentPanel from '../components/OAuthConsentPanel/OAuthConsentPanel';
import OAuthRequestExpired from '../components/OAuthRequestExpired/OAuthRequestExpired';
import useOAuthConsent from '../hooks/useOAuthConsent';
import useOAuthConsentDetails from '../hooks/useOAuthConsentDetails';

export interface OAuthConsentLocationState {
  oauthRequestId: string;
  clientName: string;
  scopes: string[];
}

const OAuthConsentPage: React.FC = () => {
  const location = useLocation<OAuthConsentLocationState | undefined>();
  const searchParams = new URLSearchParams(location.search);
  const oauthRequestId = searchParams.get('oauth_request_id') || '';
  const state = location.state;

  const {
    details,
    isLoading,
    errorMessage: fetchErrorMessage,
  } = useOAuthConsentDetails(state, oauthRequestId);
  const {
    handleConsent,
    handleDeny,
    isSubmitting,
    errorMessage: submitErrorMessage,
  } = useOAuthConsent(details?.oauthRequestId ?? '');

  if (!state && !oauthRequestId) {
    return <Redirect to="/" />;
  }

  const errorMessage = fetchErrorMessage ?? submitErrorMessage;

  if (errorMessage) {
    return (
      <AuthShell>
        <OAuthRequestExpired errorMessage={errorMessage} />
      </AuthShell>
    );
  }

  if (isLoading || !details) {
    return (
      <AuthShell>
        <AuthPanel>
          <Loading size={48} />
        </AuthPanel>
      </AuthShell>
    );
  }

  const visibleScopes = details.scopes.filter((scope) => scope !== 'openid');

  return (
    <AuthShell>
      <OAuthConsentPanel
        clientName={details.clientName}
        scopes={visibleScopes}
        isSubmitting={isSubmitting}
        onConsent={handleConsent}
        onDeny={handleDeny}
      />
    </AuthShell>
  );
};

export default OAuthConsentPage;
